import logger from '@/logger';
import type { LocationQueryValue, Router } from 'vue-router';

const log = logger.getChild('modal');

export enum MODAL {
  DELETE_CAMPAIGN = 'DELETE_CAMPAIGN',
  CREATE_CAMPAIGN = 'CREATE_CAMPAIGN',
  LAUNCH_CAMPAIGN = 'LAUNCH_CAMPAIGN',
  END_CAMPAIGN = 'END_CAMPAIGN',
  SET_CAMPAIGN_DRAFT = 'SET_CAMPAIGN_DRAFT',
  ARCHIVE_CAMPAIGN = 'ARCHIVE_CAMPAIGN',
  UNARCHIVE_CAMPAIGN = 'UNARCHIVE_CAMPAIGN',
  IMPORT_CSV = 'IMPORT_CSV',
  DELETE_CSV = 'DELETE_CSV',
  RENAME_CSV = 'RENAME_CSV',
  CALL_TIMES_SETTING = 'CALL_TIMES_SETTING',
  IMPORT_DNC = 'IMPORT_DNC',
  DELETE_DNC = 'DELETE_DNC',
  RENAME_DNC = 'RENAME_DNC',
  DELETE_DNC_RECORD = 'DELETE_DNC_RECORD',
  DISABLE_LOCAL_DNC = 'DISABLE_LOCAL_DNC',

  // temporary
  NOT_IMPLEMENTED = 'NOT_IMPLEMENTED',
}

export const modalValues = new Set(Object.values(MODAL));

export type ModalMeta = {
  id?: string;
  tab?: string;
  csvId?: string;
  currentDay?: string;
};

export type ModalProps = {
  meta: ModalMeta | null;
};

let router: Router;
export const initModal = (initRouter: Router): void => {
  router = initRouter;
};

export const getModalByString = (
  name: string | undefined | null | LocationQueryValue[],
): MODAL | null => {
  if (!name || Array.isArray(name) || !modalValues.has(name as MODAL)) {
    return null;
  }
  return name as MODAL;
};

export const parseModalMeta = (
  meta: string | undefined | null | LocationQueryValue[],
): ModalMeta | null => {
  if (!meta || Array.isArray(meta)) {
    return null;
  }
  try {
    const parsed = JSON.parse(meta);
    if (typeof parsed !== 'object') {
      log.error(`Invalid modal meta: ${meta}`);
      return null;
    }

    // prevent potential XSS
    return {
      id: parsed.id,
      tab: parsed.tab,
      csvId: parsed.csvId,
      currentDay: parsed.currentDay,
    };
  } catch {
    log.error(`Invalid modal meta: ${meta}`);
    return null;
  }
};

export const openModal = async (
  modal: MODAL,
  meta?: ModalMeta,
): Promise<void> => {
  log.log('Opening modal', { modal, meta });
  await router.push({ query: { modal, modalMeta: JSON.stringify(meta) } });
};

export const closeModal = async (): Promise<void> => {
  log.log('Closing modal');
  await router.push({
    query: {
      ...router.currentRoute.value.query,
      modal: undefined,
      modalMeta: undefined,
    },
  });
};

export const updateShow = async (show: boolean): Promise<void> => {
  if (!show) {
    await closeModal();
  }
};
